import Dexie, { type Table } from 'dexie'
import type { IndexedDbDriver } from '#src/interfaces/IndexedDdDriver'
import type { ClientTicket } from '#src/stores/tickets/types'

const DB_NAME = 'seven-client-retail-slips'

class SevenClientRetailSlips extends Dexie {
  slipActionsRecords: Table<ClientTicket, string>

  constructor() {
    super(DB_NAME)

    this.version(1).stores({
      slipActionsRecords: 'feBetslipId,timestamp,linkCode'
    })

    this.slipActionsRecords = this.table('slipActionsRecords')
  }
}

const db = new SevenClientRetailSlips()

const indexedDbDriver: IndexedDbDriver = {
  add: async (ticket: ClientTicket) => {
    await db.slipActionsRecords.add(ticket)

    return ticket
  },

  update: async (ticket: ClientTicket) => {
    await db.slipActionsRecords.put(ticket)

    return ticket
  },

  removeAll: async (retentionDays = 0) => {
    const cutoffInMs = Date.now() - retentionDays * 24 * 60 * 60 * 1_000

    return db.slipActionsRecords.where('timestamp').below(cutoffInMs).delete()
  },

  getById: (id: string) => db.slipActionsRecords.get(id),

  getAll: () => db.slipActionsRecords.toArray()
}

export { indexedDbDriver }
